import { useRedirectWhenUnauthenticated } from "@vellum/micro-app-auth";
import { RequireAuth as SharedRequireAuth } from "@vellum/micro-app-auth/router";

import { getHubUrl } from "@/config";

export function RequireAuth() {
  useRedirectWhenUnauthenticated(getHubUrl());

  return (
    <SharedRequireAuth
      unauthenticated={() => (
        <div className="flex items-center justify-center py-16">
          <p className="m-0 text-sm text-gray-600">Redirecting to Hub…</p>
        </div>
      )}
    />
  );
}
